import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MechanicImg from "../../Assests/Images/Margin.png";

export default function FuelGrowth() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBecomeProvider = () => {
    navigate('/signup');
  };

  return (
    <section className="growth-section">
      {/* Background Gradient Grid Lines (Stoke) */}
      <div className="grid-lines">
        <div className="v-line l-left"></div>
        <div className="v-line l-right"></div>
      </div>

      <div className="container">
        {/* Header Section */}
        <div className="header-content">
          <h1 className="growth-title">
            Fuel Your Business Growth <br />
            <span className="title-thin">With Fuelingo</span>
          </h1>
          <p className="growth-desc">
            Reach thousands of local car owners in a 5km radius. Manage your schedule,
            chat with customers, and secure payments—all in one place.
          </p>
        </div>

        {/* Main Content Card */}
        <div className="growth-card">
          {/* Left Side: Image */}
          <div className="image-wrapper">
            <img src={MechanicImg} alt="Mechanic working" className="mechanic-image" />
          </div>

          {/* Right Side: Text & Button */}
          <div className="text-wrapper">
            <div className="text-content">
              <p className="primary-text">
                Join the elite network. Scale your vehicle service business with our platform.
              </p>
              <p className="secondary-text">
                Fill your slow days with instant bookings from nearby drivers.
                Diagnose problems and provide quotes before the car even enters your shop.
              </p>
            </div>

            {/* Button at Bottom Right */}
            <div className="button-area">
              <button className="provider-btn" onClick={handleBecomeProvider}>
                <span className="status-dot"></span>
                Become a Provider
              </button>
            </div>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        .growth-section {
          background-color: #ffffff;
          padding: 40px 20px;
          position: relative;
          font-family: 'Inter', sans-serif;
          overflow: hidden;
          display: flex;
          justify-content: center;
        }

        .container {
          width: 100%;
          max-width: 1100px;
          position: relative;
          z-index: 2;
        }

        /* --- Gradient Grid Lines --- */
        .grid-lines {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 1;
        }
        .v-line {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 1px;
        }
        .l-left { left: 12%; }
        .l-right { right: 12%; }

        /* --- Header Styling --- */
        .header-content {
          margin-bottom: 50px;
          text-align: left;
        }
        .growth-title {
          font-size: clamp(30px, 4.2vw, 43px);
          font-weight: 600;
          color: #111;
          line-height: 1.1;
          letter-spacing: -0.03em;
          margin-bottom: 15px;
        }
        .title-thin {
          font-weight: 300;
          color: #444;
        }
        .growth-desc {
          font-size: 16px;
          color: #666;
          max-width: 480px;
          line-height: 1.6;
        }

        /* --- Card Styling --- */
        .growth-card {
          background: #FFFFFF;
          border: 1px solid #f0f0f0;
          border-radius: 24px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0,0,0,0.03);
          min-height: 480px;
        }

        .image-wrapper {
          padding: 15px;
        }
        .mechanic-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 16px;
        }

        .text-wrapper {
          padding: 50px 40px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          /* Adding the subtle dot pattern background from figma */
          background-image: radial-gradient(#f0f0f0 1px, transparent 1px);
          background-size: 20px 20px;
          background-position: center;
        }

        .primary-text {
          font-size: 18px;
          font-weight: 500;
          color: #111;
          margin-bottom: 25px;
          line-height: 1.5;
        }
        .secondary-text {
          font-size: 15px;
          color: #666;
          line-height: 1.7;
        }

        /* --- Button Styling --- */
        .button-area {
          display: flex;
          justify-content: flex-end;
        }
        .provider-btn {
          background: white;
          border: 1px solid #e5e7eb;
          padding: 12px 24px;
          border-radius: 30px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 2px 10px rgba(0,0,0,0.02);
        }
        .provider-btn:hover {
          background: #f9fafb;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
        }
        .status-dot {
          width: 8px;
          height: 8px;
          background-color: #22c55e;
          border-radius: 50%;
          box-shadow: 0 0 8px rgba(34, 197, 94, 0.5);
        }

        /* --- Responsive Logic --- */
        @media (max-width: 991px) {
          .growth-section { padding: 60px 16px; }
          .l-left, .l-right { display: none; }
          .growth-card { grid-template-columns: 1fr; }
          .image-wrapper { height: 350px; }
          .text-wrapper { padding: 30px 20px; }
          .button-area { justify-content: center; margin-top: 30px; }
          .provider-btn { width: 100%; justify-content: center; }
        }
      `}} />
    </section>
  );
}